// extracted by mini-css-extract-plugin
export var orderSummary = "_rz-0";
export var showMoreLessButton = "_rz-1";